import {Pipe, PipeTransform} from '@angular/core';
import {ChangelogItem} from '../../../@backend/modules/@documentation/models/changelog-item.model';

@Pipe({
  name: 'logItemFilter'
})
export class LogItemFilterPipe implements PipeTransform {

  transform(items: ChangelogItem[], category: string): any {
    return items.filter(item => item.category === category);
  }

}
